import { render } from "./DateAndTimeRange.vue?vue&type=template&id=823a991c"
import script from "./DateAndTimeRange.vue?vue&type=script&lang=ts"
export * from "./DateAndTimeRange.vue?vue&type=script&lang=ts"
script.render = render

export default script